export default {
  en: {
    banner_title: 'How can I freely access streaming media with PlexVPN?',
    banner_des1: 'How can I freely access streaming media with PlexVPN?',
    banner_des2: ' Just download PlexVPN, with one click, you can quickly and smoothly access Netflix, Hulu, BBC iPlayer, HBO, and other video sites. PlexVPN provides you high-quality servers, allowing you to enjoy movies, shows, or sports events, without any delay or buffering. ',
    banner_btn: 'Get PlexVPN Now',
    whyNeed_title: 'Why use a VPN to watch streaming media',
    whyNeed_des1: 'GEO restrictions',
    whyNeed_des2: 'ISP limits connection speed',
    whyNeed_des3: 'Slow speed, network stuck',
    whyNeed_des4: 'Intrusive advertising',
    whyNeed_des5: 'ISP monitoring',
    whyNeed_des6: 'Data risk during streaming',
    benefit_title: 'PlexVPN allows you to enjoy watching streaming media',
    benefit_item1: 'Access your favorite content anytime, anywhere',
    benefit_item2: 'Watch HD/4K videos smoothly',
    benefit_item3: 'Watch on any devices',
    benefit_item4: 'No bandwidth and data restrictions',
    getPlex: 'Get PlexVPN Now',
    downloadPlex: 'Download PlexVPN',
    stream_list_title: 'Steaming media',
    stream_list_title1: 'Free access to global Netflix',
    stream_list_title2: 'Enjoy BBC iPlayer outside the UK',
    stream_list_title3: 'Unlock the GEO restrict of Hulu',
    stream_list_title4: 'Access HBO from anywhere',
    stream_list_title5: 'Unlock Disney+ movies',
    stream_list_title6: 'Access Nicovideo with PlexVPN',
    stream_list_title7: 'Easily view VIP from any country',
    stream_list_title8: 'The best VPN for AbemaTV',
    stream_list_title9: 'How to watch TVer outside Japan',
    stream_list_title10: 'Unlock DMM for users outside Japan',
    stream_list_des1: 'Netflix is a subscription-based streaming service. You can watch various Netflix original works, TV shows, movies, and documentaries, etc. Netflix has different resource libraries in each country/region.',
    stream_list_des2: 'iPlayer is a network TV and broadcast platform. You can watch free TV shows, movies, sports events, etc, but only available in the UK.',
    stream_list_des3: 'Hulu provide paid service for movies and TV shows. You can watch movies, series, anime, TV shows, sports channels, etc. Only available in the United States and Japan. ',
    stream_list_des4: 'HBO (Family Box Office) provides high-quality TV programs-original series, drama movies, live sports programs, etc. in the United States, Canada, Eastern Europe, Latin America, and some countries/regions of Asia.',
    stream_list_des5: 'Whether it is the Disney classic old movies or Marvel movie, you can watch them all with a Disney + subscription. Currently, it is only available in the United States, Canada, the United Kingdom, New Zealand, Australia, and some European countries.',
    stream_list_des6: 'Niconico is an online bullet screen video-sharing site in Japan. Viewers can leave comments on the video and appear on the video as bullet screen. It only can be played in Japan. You can access the content on Niconico abroad through PlexVPN.',
    stream_list_des7: 'Viu is a free OTT platform video site for Hong Kong, Singapore, Malaysia, Indonesia, and India markets. You can use PlexVPN to watch free high-quality Korean dramas, variety shows, and Asia\'s best entertainment shows on Viu anytime and anywhere.',
    stream_list_des8: 'AbemaTV provides online streaming services with different types of channels in Japan. With PlexVPN, you can smoothly watch TV shows, dramas, variety shows, documentaries, animations, sports events, etc. on AbemaTV.',
    stream_list_des9: 'TVer provides ad-free VOD service, allowing you to watch ten programs each week provided by Nippon TV, Asahi TV, TBS TV, Fuji TV, and TV TOKYO for free. It is only available in Japan.',
    stream_list_des10: 'DMM is the leading online entertainment distributor in Japan, providing a variety of services and products. Their most popular products include video streaming and games. You can access DMM smoothly through PlexVPN without traffic restrictions.',
    stream_list_moive: 'Top 3 movies:',
    stream_list_moive1: 'La La Land|Roma|Bird Box',
    stream_list_moive2: 'I Remember You|Phoenix|A United Kingdom',
    stream_list_moive3: 'Minding the Gap|Too Funny to Fail|Crime + Punishment',
    stream_list_moive4: 'Blade Runner 2049|His Dark Materials|Watchmen',
    stream_list_moive5: 'Avengers: Endgame|Coco|Aladdin',
    feature_title: 'Why should I select PlexVPN?',
    features_title1: 'Bypass GEO restrictions',
    features_title2: 'Gigabit acceleration, unlimited bandwidth',
    features_title3: 'High-quality servers all around the world',
    features_title4: 'Data encryption, no logs',
    features_title5: 'Support for multi-platform devices',
    features_title6: 'Friendly customer & technical support',
    features_con1: 'No matter where you are, PlexVPN can help you access your favorite contents on multiple devices without GEO restrictions.',
    features_con2: 'PlexVPN has no bandwidth and traffic limits. You can watch ultra HD videos smoothly, without any delay or buffering.',
    features_con3: 'PlexVPN provides high-quality servers to unlock mainstream video websites, such as Netflix, Hulu, HBO, etc. With our high-speed and stable servers, you can watch your favorite videos smoothly.',
    features_con4: 'With the latest & strongest ECC encryption technology, PlexVPN can hide your IP address and encrypt your network data. No one knows what you are doing.',
    features_con5: 'PlexVPN has user-friendly clients for Android, iOS, macOS, Ubuntu, and Android TV devices. ',
    features_con6: 'If you encountered any problems while using PlexVPN, or you have any suggestions or advice for us, you can contact our customer support team via online feedback in the APP.',
    footer_con1: 'User praise/trust rating',
  },
  zh: {
    banner_title: '如何使用 PlexVPN 自由访问流媒体',
    banner_des1: '想要随时随地安全快速地访问喜欢的内容？',
    banner_des2: '您只需要下载 PlexVPN，一键连接，即可快速流畅地观看访问 Netflix、Hulu、BBC iPlayer、HBO 等视频网站。PlexVPN 为您提供专用的优化服务器，可实现快速、不间断、无缓冲的流传输，让您能够自由欣赏电影、节目或体育赛事。',
    banner_btn: '立即获取 PlexVPN',
    whyNeed_title: '为什么需要使用 VPN 观看流媒体',
    whyNeed_des1: '地域封锁',
    whyNeed_des2: 'ISP 限制连接速度',
    whyNeed_des3: '速度慢，卡顿',
    whyNeed_des4: '侵入性广告',
    whyNeed_des5: 'ISP 监控',
    whyNeed_des6: '串流时的数据风险',
    benefit_title: 'PlexVPN 让你享受观看流媒体的乐趣',
    benefit_item1: '随时随地访问喜欢的内容',
    benefit_item2: '流畅观看 HD / 4K 视频',
    benefit_item3: '在任何设备上观看',
    benefit_item4: '没有宽带和流量限制',
    getPlex: '立即获取 PlexVPN',
    downloadPlex: '下载 PlexVPN',
    stream_list_title: '流媒体',
    stream_list_title1: '自由访问美国 Netflix',
    stream_list_title2: '在英国境外享受 BBC iPlayer',
    stream_list_title3: '解除对美国 Hulu 的封锁',
    stream_list_title4: '从任何地方访问 HBO',
    stream_list_title5: '解锁 Disney+精彩影视',
    stream_list_title6: '使用 PlexVPN 访问 Nicovideo',
    stream_list_title7: '从任何国家轻松观看 VIU',
    stream_list_title8: '适用于 AbemaTV 的最佳 VPN',
    stream_list_title9: '如何在日本境外观看 TVer',
    stream_list_title10: '取消国外用户访问 DMM 的限制',
    stream_list_des1: 'Netflix 是订阅式流媒体服务。 您可以观看众多 Netflix 原创 作品、电视节目、电影和纪 录片等。Netflix 在每个国家 地区的资源库都不尽相同。',
    stream_list_des2: 'iPlayer 是一个网络电视和广播 平台。您可以观看免费的电视 节目、电影、体育赛事等，但 仅在英国提供。',
    stream_list_des3: 'Hulu 是一个付费观看影视节目 的互联网网站。您可以观看电 影，连续剧，动漫，电视节目， 体育频道等等。仅在美国和日 本可用。',
    stream_list_des4: 'HBO（家庭票房）在美国、加 拿大、东欧、拉丁美洲和亚洲 的部分国家/地区提供优质电 视节目-原创系列，戏剧电影 和现场体育节目等等。',
    stream_list_des5: '无论是迪士尼经典老电影，还 是漫威电影，您都可以通过订阅 Disney +来观看。目前仅在 美国、加拿大、英国、新西兰、 澳大利亚和一些欧洲国家可以 访问。',
    stream_list_des6: 'Niconico 是日本的一个在线弹 幕视频分享网站。观赏者可在 视频上留言并以弹幕的形式出 现在视频上。只能在日本境内 播放。您可以通过 PlexVPN 在 境外访问 Niconico 上的内容。',
    stream_list_des7: 'Viu 是针对香港、新加坡、马来 西亚、印尼及印度市场的免费 OTT 平台影片网站。您可以使 用 PlexVPN 随时随地观看 Viu 免费的优质韩国戏剧，综艺节 目和亚洲最佳娱乐节目。',
    stream_list_des8: 'AbemaTV 是一家日本在线流 媒体服务，分不同类型的频道。 借助 PlexVPN，您可以流畅观 看 AbemaTV 上的电视节目、 戏剧、综艺、纪录片、动画、 体育赛事等。',
    stream_list_des9: 'TVer 是无广告影片点播服务， 可以让您免费收看日本电视台、 朝日电视台、TBS 电视台、富 士电视台以及东京电视台各自 每周提供的十档节目。只能在 日本境内观看。',
    stream_list_des10: 'DMM 是日本主要的在线娱乐分 销商，可提供各种不同的服务 和产品。他们最受欢迎的产品 包括视频流和游戏。您可以使 用 PlexVPN 流畅访问 DMM， 而没有流量限制。',
    stream_list_moive: '排名前三电影:',
    stream_list_moive1: '爱乐之城|罗马|蒙上你的眼',
    stream_list_moive2: '我记得你|不死鸟|联合王国',
    stream_list_moive3: '联合王国|Too Funny to Fail|罪与罚',
    stream_list_moive4: '银翼杀手2049|黑暗物质三部曲|守望者',
    stream_list_moive5: '复仇者联盟4：终局之战|寻梦环游记|阿拉丁',
    feature_title: '为什么选择 PlexVPN',
    features_title1: '绕过地理位置封锁',
    features_title2: '千兆加速，无限流量',
    features_title3: '优质服务器遍布全球',
    features_title4: '数据加密，无日志',
    features_title5: '设备兼容，易于使用',
    features_title6: '友好的客服 & 技术支持',
    features_con1: '无论您身在哪里，都可以使用 PlexVPN 在多种设备上观看喜爱的内容，而不受地域限制。',
    features_con2: 'PlexVPN 没有宽带和流量限制，即使是超高清视频也可以流畅播放，不会出现延迟或缓冲。',
    features_con3: 'PlexVPN 提供 Netflix、Hulu、HBO 等主流视频媒体高速专线，让你能够流畅观看喜欢的内容。',
    features_con4: 'PlexVPN 通过最新、最强的椭圆曲线加密技术，隐藏您的 IP 地址并加密您的数据，没人能看到您在做什么。',
    features_con5: 'PlexVPN 拥有 Android、iOS、Window、MacOS，Ubuntu 及 Android TV 等客户端，界面友好，简单易用。',
    features_con6: '使用过程中遇到任何问题，或者您对 PlexVPN 有任何的意见或建议，都可以通过客户端在线反馈联系我们。',
    footer_con1: '用户好评度/信任等级',
  }
}


// WEBPACK FOOTER //
// ./src/views/promotion/StreamMedia/lang.js